import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import PhoneImg from "../assets/iphone-2.png";
import Icon1 from "../assets/list-icon-1.png";
import Icon2 from "../assets/list-icon-2.png";
import Icon3 from "../assets/list-icon-3.png";

// ==================== SHARED STYLES ====================

const circle = {
  height: "86px",
  width: "86px",
  borderRadius: "50%",
  background: "#7b4efd",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
};

const iconImg = {
  width: "80px",
  height: "80px",
  objectFit: "contain",
};

const textBlock = (title, desc) => (
  <Box sx={{ textAlign: "left" }}>
    <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>{title}</Typography>
    <Typography sx={{ color: "#666", fontSize: "14px", mt: 1 }}>
      {desc}
    </Typography>
  </Box>
);

// ==================== LEFT CONNECTOR ====================
// Dashed line + top dot aligned to circle position

const leftConnector = {
  position: "relative",
  width: "100%",
  height: "50px",

  "&::before": {
    content: '""',
    height: "100%",
    width: "2px",
    borderLeft: "2px dashed #794efd",
    position: "absolute",
    top: 0,
    left: "calc(100% - 43px)", // aligns to circle center
  },

  "&::after": {
    content: '""',
    height: "10px",
    width: "10px",
    background: "#794efd",
    border: "2px solid #fff",
    borderRadius: "50%",
    position: "absolute",
    top: "-5px",
    left: "calc(100% - 48px)",
  },
};

// ==================== RIGHT CONNECTOR ====================
// Top + bottom dots only

const rightConnector = {
  position: "relative",
  width: "100%",
  height: "50px",

  "&::before": {
    content: '""',
    height: "100%",
    width: "2px",
    borderLeft: "2px dashed #794efd",
    position: "absolute",
    top: 0,
    left: "40px",
    bottom: "-5px", // aligns to circle center
  },

  "&::after": {
    content: '""',
    height: "10px",
    width: "10px",
    background: "#794efd",
    border: "2px solid #fff",
    borderRadius: "50%",
    position: "absolute",
    top: "-5px",
    left: "35px",
  },
};

// ==================== MAIN COMPONENT ====================

export default function FeatureSection() {
  return (
    <Box sx={{ maxWidth: "1100px", mx: "auto", py: 6 }}>
      <Grid container spacing={4}>
        {/* LEFT GRID */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {/* 1 */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {textBlock(
                "PREMIUM VEHICLES",
                "Choose from clean, comfortable, top-quality cars."
              )}
              <Box sx={{ marginLeft: "auto" }}>
                <Box sx={circle}>
                  <img src={Icon1} style={iconImg} />
                </Box>
              </Box>
            </Box>

            <Box sx={leftConnector}></Box>

            {/* 2 */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {textBlock(
                  "RELIABLE SERVICE",
                  "Enjoy on-time pickups and trusted travel every day."
                )}
              <Box sx={{ marginLeft: "auto" }}>
                <Box sx={circle}>
                  <img src={Icon3} style={iconImg} />
                </Box>
              </Box>
            </Box>

            <Box sx={leftConnector}></Box>

            {/* 3 */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {textBlock(
                "EXPERT DRIVERS",
                "Professional drivers for safe and smooth travel."
              )}
              <Box sx={{ marginLeft: "auto" }}>
                <Box sx={circle}>
                  <img src={Icon2} style={iconImg} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* CENTER GRID */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={PhoneImg}
              style={{ width: "350px", borderRadius: "20px",height: "400px" }}
              alt="center-device"
            />
          </Box>
        </Grid>

        {/* RIGHT GRID */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {/* 1 */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={circle}>
                <img src={Icon1} style={iconImg} />
              </Box>
              <Box sx={{ marginLeft: 3 }}>
                {textBlock(
                  "EASY BOOKING",
                  "Book your ride instantly with a simple, fast process."
                )}
              </Box>
            </Box>

            <Box sx={rightConnector}></Box>

            {/* 2 */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={circle}>
                <img src={Icon2} style={iconImg} />
              </Box>
              <Box sx={{ marginLeft: 3 }}>
                {textBlock(
                "FLEXIBLE TRAVEL",
                "Rides for city, outstation, and airport trips."
              )}
              </Box>
            </Box>

            <Box sx={rightConnector}></Box>

            {/* 3 */}
            <Box sx={{ display: "flex", alignItems: "center"}}>
              <Box sx={circle}>
                <img src={Icon3} style={iconImg} />
              </Box>
              <Box sx={{ marginLeft: 3 }}>
                {textBlock(
                  "24/7 CLIENT CARE",
                  "Help is always available whenever you need it."
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
